<script setup>
import {onMounted, onUnmounted} from "vue";

const props = defineProps({
  title: {type: String, required: true},
});

let tooltipList = [];

onMounted(() => {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

})
onUnmounted(() => {
  tooltipList.forEach(tooltip => tooltip.dispose())
})
</script>

<template>
  <span data-bs-toggle="tooltip" :data-bs-title="props.title">
    <slot/>
  </span>
</template>
